// Individual drill screen (prototype renderWorker). Sub-sections live in ./worker.

import React from 'react';
import { DEMO_MODE, WORKERS } from '../engine/data';
import { useDash } from '../state';
import { WorkerPicker } from './worker/WorkerPicker';
import { WorkerHeader } from './worker/WorkerHeader';
import { WorkerKpis } from './worker/WorkerKpis';
import { SourceIsfiPanels } from './worker/SourceIsfiPanels';
import { TrendCharts } from './worker/TrendCharts';
import { PliPanel, PsiPanel } from './worker/LoadPanels';
import { OtResilience } from './worker/OtResilience';
import { RecentShifts } from './worker/RecentShifts';

export const WorkerScreen: React.FC = () => {
  const { activeWorker } = useDash();
  const w = activeWorker ? WORKERS[activeWorker] : undefined;
  if (!w) return <div className='p-10 text-muted-foreground'>Worker not found.</div>;

  return (
    <div className='flex flex-col gap-5'>
      <div>
        <WorkerPicker />
        <WorkerHeader w={w} />
        <WorkerKpis w={w} />
      </div>
      {!DEMO_MODE.live && <SourceIsfiPanels w={w} />}
      <TrendCharts w={w} />
      {!DEMO_MODE.live && (
        <>
          <PliPanel w={w} />
          <PsiPanel w={w} />
          <OtResilience w={w} />
          <RecentShifts w={w} />
        </>
      )}
    </div>
  );
};
